import { render, staticRenderFns } from "./DocumentTemplateHeaderPreview.vue?vue&type=template&id=77a7b7e6&scoped=true&lang=pug&"
import script from "./DocumentTemplateHeaderPreview.vue?vue&type=script&lang=js&"
export * from "./DocumentTemplateHeaderPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a7b7e6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VImg,VProgressCircular,VRow})
